import { Box, Tooltip, Typography } from "@mui/material";
import { v2PartyNumbersSchema } from "../api/v2";

/** Show only validated enrichment; never infer a number from registry text. */
export const CorporateNumbers = ({
  party,
}: {
  party: unknown;
}): JSX.Element | null => {
  const parsed = v2PartyNumbersSchema.safeParse(party);
  const match = parsed.success ? parsed.data.法人番号の突合 : null;
  if (!match || (!match.法人番号 && !match.会社法人等番号)) return null;
  return (
    <Tooltip title="登記の記載ではなく、法人マスタと照合して特定した番号">
      <Box sx={{ minWidth: 0, overflowWrap: "anywhere" }} tabIndex={0}>
        {(["法人番号", "会社法人等番号"] as const).map((label) =>
          match[label] ? (
            <Typography
              key={label}
              variant="caption"
              color="text.secondary"
              component="div"
            >
              {label}（法人マスタ）: {match[label]}
            </Typography>
          ) : null
        )}
      </Box>
    </Tooltip>
  );
};
